import React from "react";
import "../loading/singlePulse/SinglePulse.scss";
const LoadingButton = (props) => {
  return (
    <>
      <button
        className={props.className}
        type="submit"
        onMouseEnter={props.onMouseEnter}
        onClick={props.onClick}
        disabled={props.isLoading || props.disabled}
      >
        {!props.isLoading ? (
          <>{props.buttonText}</>
        ) : (
          <div className="display__col">
            <p>{props.buttonText}</p>
            <div className="container">
              <span className="circle"></span>
              <span className="circle"></span>
              <span className="circle"></span>
              <span className="circle"></span>
            </div>
          </div>
        )}
      </button>
    </>
  );
};

export default LoadingButton;
